module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_up.9bc8f22a.svg";